import { Icons, InputErrorMessage } from '@commenda/kakashi';
import { TSetNotification } from '@commenda/types/src/random';
import { StakeholderType } from '@prisma/client';
import { TShareholderVsSharePercentageMap } from '../../EquityInfo/types';
import { EquityAmountInput } from '../../us-corporate-stakeholders/EquityInfo/EquityAmountInput';

type CorporateShareholderEquitySplitInputProps = {
  isDecimalEquityPercentageAllowed: boolean;
  selectedStakeholders: TShareholderVsSharePercentageMap;
  stakeholderId: string;
  idx: number;
  type: StakeholderType;
  onEquityAmountChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    stakeholderId: string,
    type: StakeholderType
  ) => void;
  onEditShareholderDetails: (stakeholderId: string) => void;
  stakeholderIdsWithError: string[];
  setNotification: TSetNotification;
  onChangeShareholder: (stakeholderIds: string[]) => void;
  disabled?: boolean;
  setCapTableTransactionIdsToDelete: React.Dispatch<
    React.SetStateAction<string[]>
  >;
};

const CorporateShareholderEquitySplitInput = ({
  isDecimalEquityPercentageAllowed,
  selectedStakeholders,
  stakeholderId,
  idx,
  type,
  onEquityAmountChange,
  onEditShareholderDetails,
  stakeholderIdsWithError,
  setNotification,
  onChangeShareholder,
  disabled = false,
  setCapTableTransactionIdsToDelete,
}: CorporateShareholderEquitySplitInputProps) => {
  const onDeleteShareholder = async (stakeholderId: string) => {
    if (selectedStakeholders[stakeholderId].capTableTransactionId) {
      setCapTableTransactionIdsToDelete((prev) => [
        ...prev,
        selectedStakeholders[stakeholderId].capTableTransactionId,
      ]);
    }

    onChangeShareholder(
      Object.keys(selectedStakeholders).filter((each) => each !== stakeholderId)
    );
  };

  return (
    <div className="w-full border-b border-b-stroke-3 py-2.5 px-4">
      <div className="flex gap-2 items-center justify-between relative">
        <EquityAmountInput
          isDecimalEquityPercentageAllowed={isDecimalEquityPercentageAllowed}
          value={selectedStakeholders[stakeholderId]?.sharePercentage}
          name={selectedStakeholders[stakeholderId].name}
          idx={idx}
          key={stakeholderId}
          max={100}
          onChange={(e) => {
            onEquityAmountChange(e, stakeholderId, type as StakeholderType);
          }}
          disabled={disabled}
        />

        {!disabled ? (
          <div className="absolute top-0 right-0 h-full flex items-center">
            <div
              className="p-2 group hover:bg-bg-secondary-hover rounded-sm cursor-pointer"
              onClick={() => onEditShareholderDetails(stakeholderId)}
            >
              <Icons.Edit01 className="h-5 w-5  text-button-tertiary-fg group-hover:text-button-tertiary-fg-hover" />
            </div>
            <div
              className="p-2 hover:bg-bg-secondary-hover rounded-sm cursor-pointer group"
              onClick={() => onDeleteShareholder(stakeholderId)}
            >
              <Icons.X className="h-5 w-5 text-button-tertiary-fg group-hover:text-button-tertiary-fg-hover " />
            </div>
          </div>
        ) : null}
      </div>
      {stakeholderIdsWithError?.includes(stakeholderId) ? (
        <InputErrorMessage className="pl-7" message="Missing Details" />
      ) : null}
    </div>
  );
};

export default CorporateShareholderEquitySplitInput;
